import { useQuery } from '@tanstack/react-query';
import { analyticsAPI } from '../../../lib/api';
import type { DateRange } from './useAnalyticsData';

const STALE_TIME_30MIN = 30 * 60 * 1000;
const GC_TIME = 30 * 60 * 1000;

export interface MRRTrendItem {
  month: string;
  mrr: string;
  newMRR: string;
  churnedMRR: string;
}

export function useMRRTrend(organizationId: string | undefined, months?: number) {
  return useQuery<MRRTrendItem[]>({
    queryKey: ['analytics', 'revenue', 'mrr-trend', organizationId, months],
    queryFn: async () => {
      const { data } = await analyticsAPI.getMRRTrend({
        organizationId: organizationId!,
        months,
      });
      return data;
    },
    enabled: !!organizationId,
    staleTime: STALE_TIME_30MIN,
    gcTime: GC_TIME,
  });
}
